

<script lang="ts">
  import type { OrganizationFrame } from "@kontextwerk/control-web-client"
  import type { OrgaViewFrameContext } from "../../context"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import type { PageContext } from "./navigation"
  import CalendarTab from "./tabs/Calendar"
  import CommunicationTab from "./tabs/communication"
  import OverviewTab from "./tabs/Overview"
  import { resolveAllowedEmployeeIds } from "../../../_shared/_logic/permissions-model"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: OrgaViewFrameContext
    activeTab: string
  }>()

  const pageContext = $derived.by<PageContext>(() => {
    const canManageScheduling = viewFrameContext.permissions.allows("kehrblatt.scheduling", "manage")
    // The integration overview follows its own core capability; setup stays personal.
    const allowedIntegrationEmployeeIds = resolveAllowedEmployeeIds(
      viewFrameContext.permissions,
      "core.calendar_integrations",
      viewFrameContext.currentMembershipId,
      "view",
    )
    const allowedManageEmployeeIds = resolveAllowedEmployeeIds(
      viewFrameContext.permissions,
      "kehrblatt.scheduling",
      viewFrameContext.currentMembershipId,
      "manage",
    )

    return {
      organization: viewFrameContext.organization,
      canManageScheduling,
      subscriptionRestrictionActive: Boolean(viewFrameContext.subscriptionRestrictionActive),
      allowedIntegrationEmployeeIds,
      allowedManageEmployeeIds,
    }
  })
</script>

{#if activeTab === "overview"}
  <OverviewTab {viewFrameContext} {pageContext} />
{:else if activeTab === "calendar"}
  <CalendarTab {viewFrameContext} {pageContext} />
{:else if activeTab === "communication"}
  <CommunicationTab {pageContext} />
{/if}
